  <template>
    <div>
      <select class='form-control' v-model="value" :name="name" @change="handleSelectChange">
        <option value="" disabled hidden >{{ placeholder}}</option>
        <option  v-for="option in options"
          :key="option.value"
          :value="option.value"
        > {{option.text}} </option>
      </select>

      <validation-provider rules="required" v-slot="{ errors }" >
        <input :name="buildInputName"  v-model="value" hidden>
        <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
      </validation-provider>
  </div>
</template>

<script>

export default {
  name: 'crm_select',
  props: {
    placeholder: { type: String },
    options: { type: Array, required: true },
    name: { type: String, required: true },
    current: { type: String },
    onChange: { type: Function }
  },
  data: function () {
    return {
      value: ''
    };
  },
  mounted () {
    this.value = this.current ? this.current : '';
  },
  methods: {
    handleSelectChange (e) {
      const selected = e.target.options[e.target.options.selectedIndex];
      const { value, text } = selected;
      this.onChange(value, text);
    },
    buildInputName () {
      return `select-${this.name}`;
    }
  }
};
</script>
